import gql from 'graphql-tag'

export const GET_REPORT = gql`
  query GetReportConcatenator(
    $id_client: ID
    $id_site: ID
    $id_machine_type: ID
    $id_machine: ID
    $from: String!
    $to: String!
  ) {
    reportConcatenator(
      id_client: $id_client
      id_site: $id_site
      id_machine_type: $id_machine_type
      id_machine: $id_machine
      from: $from
      to: $to
    )
  }
`

export const GET_EXCEL = gql`
  query GetReportConcatenatorExcel(
    $id_client: ID
    $id_site: ID
    $id_machine_type: ID
    $id_machine: ID
    $from: String!
    $to: String!
  ) {
    reportConcatenatorExcel(
      id_client: $id_client
      id_site: $id_site
      id_machine_type: $id_machine_type
      id_machine: $id_machine
      from: $from
      to: $to
    )
  }
`
